import React, { useEffect, useState, useRef } from 'react';
import { Input, Modal, Spin  } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { getSafeCodeRequest, baseURL } from '../../api/request';
import Icon from '../../components/Icon';

/**
 * 图形验证码弹窗
 * @param {*} props 
 * @returns 
 */

function ImgCodeModal(props) {
  const {
    open = false,
    setOpen = () => {},
    onOk = () => {}, // 确认回调用
    onCancel = () => {} // 取消回调
  } = props;
  const [safeCode, setSafeCode] = useState('');
  const [imgCodeValue, setImgCodeValue] = useState('');

  useEffect(() => {
    getSafeCode()
  },[])

  //获取验证码
  const getSafeCode = () => {
    getSafeCodeRequest({}).then(res => {
      if(res.code === 'SUCCESS') {
        setSafeCode(res.data)
      }
    })
  }

  return (
    <Modal 
      title="请输入图形验证码" 
      className='login-msg-modal' 
      open={open} 
      onOk={() => {
        onOk(imgCodeValue, safeCode)
        setOpen(false);
      }} 
      onCancel={()=>{
        onCancel();
        setOpen(false);
      }} 
      cancelText="取消" 
      okText="发送" 
    >
      <div className='login-safe-code'>
        <div
          className='modal-input'
        >
          <Input
            prefix={<Icon name="phone"/>}
            placeholder="验证码"
            suffix={<ReloadOutlined className='ico-reload' onClick={getSafeCode}/>}
            value={imgCodeValue}
            onChange={(v)=>{
              setImgCodeValue(v.target.value)
            }}
          />
        </div>
        <Spin spinning={!safeCode.captcha_image}>
          <img src={safeCode.captcha_image ? `${baseURL}${safeCode.captcha_image}` : ''} alt='' onClick={getSafeCode} style={{opacity: safeCode.captcha_image ? 1 : 0}}/>
        </Spin>
      </div>
    </Modal>
  )
}

export default ImgCodeModal;